export const userAccess = {
  'adminOnly': ['ADMIN'],
  // Ödeme Al
  'merchantOrder': ['ADMIN', 'MERCHANT_SALESMAN', 'SALES_PERSON', 'BRANCH_MANAGER', 'EVENT_OWNER'],
  // Bilet Kontrol
  'checkBooking': ['ADMIN', 'BRANCH_MANAGER', 'TICKET_CONTROL'],
  // Şube Raporları
  'branchAnalytics': ['ADMIN', 'BRANCH_MANAGER', 'FINANCE_MANAGER', 'EVENT_OWNER'],
  // Kart Eşleştirme
  'pairWallet': ['ADMIN', 'BRANCH_MANAGER', 'EVENT_OWNER', 'CASH_PERSON', 'CREDIT_CARD_PERSON'],
  // Cüzdan Hareketleri Görüntüleme
  'userTransactions': ['ADMIN', 'CASH_PERSON', 'CREDIT_CARD_PERSON' ],
  // Bakiye Yükleme - Nakit
  'loadBalance_cash': ['ADMIN', 'CASH_PERSON'],
  // Bakiye Yükleme - Kart
  'loadBalance_card': ['ADMIN', 'CREDIT_CARD_PERSON'],
}

export default userAccess;